import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";

// Downloads the server-built Dispute Packet PDF (owner/manager only).
export default function DisputePacketButton({ sessionId, ticketNumber, onDone }) {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(`/sessions/${sessionId}/dispute-packet`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `dispute-packet-${ticketNumber || sessionId}.pdf`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
      toast.success("Dispute packet downloaded");
      onDone?.();
    } catch {
      toast.error("Could not generate the dispute packet");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button data-testid="ticket-dispute-packet" onClick={download} disabled={busy}
      className="h-9 gap-2 bg-[#A0148C] px-3 text-xs font-bold hover:bg-[#80106F]">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileDown className="h-4 w-4" />} Dispute Packet (PDF)
    </Button>
  );
}
